import React from "react";
import { Link } from "react-router-dom";
import { LifeBuoy } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const HIDE = ["owner", "super_admin", "company_admin", "platform_owner"];

export default function TicketHeaderButton() {
  const auth = useAuth();
  const role = auth && auth.user ? auth.user.role : undefined;
  if (!role || HIDE.includes(role)) return null;
  return (
    <Link to="/dms/tickets" data-testid="raise-ticket-btn" title="Report a problem"
      className="flex items-center gap-1.5 rounded-lg border border-rose-200 bg-rose-50 px-3 py-1.5 text-sm font-medium text-rose-700 hover:bg-rose-100">
      <LifeBuoy size={15} /> <span className="hidden sm:inline">Raise Ticket</span>
    </Link>
  );
}
